import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.scss';

import template from './news-slider.vhtml';

export default {
	template,
	components: {
		Slick,
	},
	props: {
		more: String,
		heading: String,
		btnText: String,
	},
	data() {
		return {
			slickOptions: {
				dots: true,
				infinate: true,
				speed: 300,
				slidesToShow: 1,
				slidesToScroll: 1,
				mobileFirst: true,
				prevArrow: 'home-news__arr-left',
				nextArrow: 'home-news__arr-right',
				responsive: [
					{
						breakpoint: 600,
						settings: {
							dots: false,
							slidesToShow: 2,
							slidesToScroll: 1,
						}
					},
					{
						breakpoint: 850,
						settings: {
							dots: false,
							slidesToShow: 4,
							slidesToScroll: 1,
						}
					}
				]
			}
		};
	},
	methods: {
		next() {
			this.$refs.slick.next();
		},
		prev() {
			this.$refs.slick.prev();
		}
	},
};


// WEBPACK FOOTER //
// ./assets/_js/components/news-slider/news-slider.js